/* tslint:disable */
/* eslint-disable */
/**
 * PID Backoffice Gateway, PID Onboarding
 * Backoffice integration for PID Onboarding
 *
 * The version of the OpenAPI document: 3.1
 * Contact: viktor.dite@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface ClientV3x1
 */
export interface ClientV3x1 {
    /**
     * 
     * @type {string}
     * @memberof ClientV3x1
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientV3x1
     */
    'fullName'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ConsultantQrActivationProcessStateV3x1 = {
    ACTIVATION_COMMITTED: 'ACTIVATION_COMMITTED',
    ACTIVATION_CREATED: 'ACTIVATION_CREATED',
    ACTIVATION_INITIALIZED: 'ACTIVATION_INITIALIZED',
    DOCUMENTS_TO_SIGN_PREPARED: 'DOCUMENTS_TO_SIGN_PREPARED',
    IDENTITY_VERIFICATION_FAILED: 'IDENTITY_VERIFICATION_FAILED',
    IDENTITY_VERIFIED: 'IDENTITY_VERIFIED',
    MANUAL_IDENTITY_VERIFICATION_REQUIRED: 'MANUAL_IDENTITY_VERIFICATION_REQUIRED',
    PROCESS_CANCELED: 'PROCESS_CANCELED',
    PROCESS_COMPLETED: 'PROCESS_COMPLETED',
    PROCESS_CREATED: 'PROCESS_CREATED',
    SIGNED_DOCUMENTS_PROCESSING_FAILED: 'SIGNED_DOCUMENTS_PROCESSING_FAILED',
    SIGNED_DOCUMENTS_PROCESSING_COMPLETED: 'SIGNED_DOCUMENTS_PROCESSING_COMPLETED'
} as const;

export type ConsultantQrActivationProcessStateV3x1 = typeof ConsultantQrActivationProcessStateV3x1[keyof typeof ConsultantQrActivationProcessStateV3x1];


/**
 * 
 * @export
 * @interface ConsultantQrActivationProcessV3x1
 */
export interface ConsultantQrActivationProcessV3x1 {
    /**
     * 
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'processUuid': string;
    /**
     * 
     * @type {ConsultantQrActivationProcessStateV3x1}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'processState': ConsultantQrActivationProcessStateV3x1;
    /**
     * 
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'pidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'investigationId'?: string;
    /**
     * 
     * @type {PhoneV3x1}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'phone': PhoneV3x1;
    /**
     * Unique identifier of subject of activation (user) used in PowerAuth activation.
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'activationUserUuid'?: string;
    /**
     * Unique identifier of PowerAuth activation
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'activationUuid'?: string;
    /**
     * Usually device name
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'activationName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'activationCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'activationSignature'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'deviceFingerprint'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'deviceBrand'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'deviceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'deviceIndustrialDesign'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'deviceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'documentSignOperationId'?: string;
    /**
     * 
     * @type {DocumentV3x1}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'mtcAgreementDocument'?: DocumentV3x1;
    /**
     * 
     * @type {DocumentV3x1}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'gdprAgreementDocument'?: DocumentV3x1;
    /**
     * 
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ConsultantQrActivationProcessV3x1
     */
    'updatedAt': string;
}


/**
 * 
 * @export
 * @interface DocumentV3x1
 */
export interface DocumentV3x1 {
    /**
     * 
     * @type {string}
     * @memberof DocumentV3x1
     */
    'documentUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentV3x1
     */
    'hash'?: string;
}
/**
 * Request wrapper for searching parameters.
 * @export
 * @interface GetActivationListRequestV3
 */
export interface GetActivationListRequestV3 {
    /**
     * 
     * @type {PageableV1x0}
     * @memberof GetActivationListRequestV3
     */
    'pageable': PageableV1x0;
    /**
     * 
     * @type {SearchProcessesSortV3}
     * @memberof GetActivationListRequestV3
     */
    'sort'?: SearchProcessesSortV3;
    /**
     * 
     * @type {Array<ProcessTypeV3x1>}
     * @memberof GetActivationListRequestV3
     */
    'processTypes': Array<ProcessTypeV3x1>;
    /**
     * 
     * @type {Array<UnifiedProcessStateV3x1>}
     * @memberof GetActivationListRequestV3
     */
    'unifiedProcessState'?: Array<UnifiedProcessStateV3x1>;
    /**
     * To obtain processes that are not in the final state.
     * @type {boolean}
     * @memberof GetActivationListRequestV3
     */
    'onlyUncompleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetActivationListRequestV3
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {PhoneWithEnumedPrefixV3x1}
     * @memberof GetActivationListRequestV3
     */
    'phone'?: PhoneWithEnumedPrefixV3x1;
    /**
     * 
     * @type {string}
     * @memberof GetActivationListRequestV3
     */
    'deviceFingerprint'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivationListRequestV3
     */
    'completedAtFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivationListRequestV3
     */
    'completedAtTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivationListRequestV3
     */
    'deviceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetActivationListRequestV3
     */
    'activationName'?: string;
    /**
     * Bank ID process
     * @type {string}
     * @memberof GetActivationListRequestV3
     */
    'userSub'?: string;
}
/**
 * Result wrapper with found processes.
 * @export
 * @interface GetActivationListResponseV3
 */
export interface GetActivationListResponseV3 {
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof GetActivationListResponseV3
     */
    'pageable': PageableResponseV1x0;
    /**
     * 
     * @type {Array<ProcessViewV3>}
     * @memberof GetActivationListResponseV3
     */
    'results': Array<ProcessViewV3>;
}
/**
 * ID card type Type referencing ../../common/PidCommon-9.0.yaml#/components/schemas/IdCardType 
 * @export
 * @enum {string}
 */

export const IdCardTypeV3x1 = {
    ID: 'ID',
    OP: 'OP',
    P: 'P',
    CA: 'CA',
    DL: 'DL',
    IR: 'IR',
    BC: 'BC',
    VS: 'VS',
    PS: 'PS',
    IX: 'IX',
    IE: 'IE',
    UNKNOWN: 'UNKNOWN'
} as const;

export type IdCardTypeV3x1 = typeof IdCardTypeV3x1[keyof typeof IdCardTypeV3x1];


/**
 * 
 * @export
 * @enum {string}
 */

export const IdScanActivationProcessStateV3x1 = {
    ACTIVATION_COMMITTED: 'ACTIVATION_COMMITTED',
    ACTIVATION_CREATED: 'ACTIVATION_CREATED',
    DOCUMENTS_TO_SIGN_PREPARED: 'DOCUMENTS_TO_SIGN_PREPARED',
    IDENTITY_VERIFICATION_COMPLETED: 'IDENTITY_VERIFICATION_COMPLETED',
    IDENTITY_VERIFICATION_FAILED: 'IDENTITY_VERIFICATION_FAILED',
    IDENTITY_VERIFICATION_INITIATED: 'IDENTITY_VERIFICATION_INITIATED',
    MANUAL_IDENTITY_VERIFICATION_REQUIRED: 'MANUAL_IDENTITY_VERIFICATION_REQUIRED',
    PROCESS_CANCELED: 'PROCESS_CANCELED',
    PROCESS_COMPLETED: 'PROCESS_COMPLETED',
    PROCESS_CREATED: 'PROCESS_CREATED',
    SIGNED_DOCUMENTS_PROCESSING_COMPLETED: 'SIGNED_DOCUMENTS_PROCESSING_COMPLETED',
    SIGNED_DOCUMENTS_PROCESSING_FAILED: 'SIGNED_DOCUMENTS_PROCESSING_FAILED'
} as const;

export type IdScanActivationProcessStateV3x1 = typeof IdScanActivationProcessStateV3x1[keyof typeof IdScanActivationProcessStateV3x1];


/**
 * 
 * @export
 * @interface IdScanActivationProcessV3x1
 */
export interface IdScanActivationProcessV3x1 {
    /**
     * 
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'processUuid': string;
    /**
     * 
     * @type {IdScanActivationProcessStateV3x1}
     * @memberof IdScanActivationProcessV3x1
     */
    'processState': IdScanActivationProcessStateV3x1;
    /**
     * 
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'pidUuid': string;
    /**
     * 
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'deviceFingerprint'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'deviceBrand'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'deviceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'deviceIndustrialDesign'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'deviceName'?: string;
    /**
     * 
     * @type {PhoneV3x1}
     * @memberof IdScanActivationProcessV3x1
     */
    'phone': PhoneV3x1;
    /**
     * Unique identifier of subject of activation (user) used in PowerAuth activation.
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'activationUserUuid': string;
    /**
     * Unique identifier of PowerAuth activation
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'activationUuid'?: string;
    /**
     * Usually device name
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'activationName'?: string;
    /**
     * Unique identifier of batch of uploaded documents
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'documentUploadSessionId'?: string;
    /**
     * ZenID investigation profile
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'ocrProfile'?: string;
    /**
     * 
     * @type {IdCardTypeV3x1}
     * @memberof IdScanActivationProcessV3x1
     */
    'idCardType'?: IdCardTypeV3x1;
    /**
     * Identifier of investigation in ZenID
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'ocrInvestigationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'identityDocumentProcessingErrorType'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'documentSignOperationId'?: string;
    /**
     * 
     * @type {DocumentV3x1}
     * @memberof IdScanActivationProcessV3x1
     */
    'mtcAgreementDocument'?: DocumentV3x1;
    /**
     * 
     * @type {DocumentV3x1}
     * @memberof IdScanActivationProcessV3x1
     */
    'gdprAgreementDocument'?: DocumentV3x1;
    /**
     * 
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof IdScanActivationProcessV3x1
     */
    'updatedAt': string;
}


/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV1x0
 */
export interface PageableResponseV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV1x0
 */
export interface PageableV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageSize': number;
}
/**
 * Type referencing ../../common/PidCommon-4.2.yaml#/components/schemas/Phone
 * @export
 * @interface PhoneV3x1
 */
export interface PhoneV3x1 {
    /**
     * End-User\'s preferred telephone number prefix
     * @type {string}
     * @memberof PhoneV3x1
     */
    'prefix': string;
    /**
     * End-User\'s preferred telephone number
     * @type {string}
     * @memberof PhoneV3x1
     */
    'phone': string;
}
/**
 * 
 * @export
 * @interface PhoneWithEnumedPrefixV3x1
 */
export interface PhoneWithEnumedPrefixV3x1 {
    /**
     * 
     * @type {string}
     * @memberof PhoneWithEnumedPrefixV3x1
     */
    'prefix': PhoneWithEnumedPrefixV3x1PrefixEnum;
    /**
     * End-User\'s preferred telephone number
     * @type {string}
     * @memberof PhoneWithEnumedPrefixV3x1
     */
    'phone': string;
}

export const PhoneWithEnumedPrefixV3x1PrefixEnum = {
    _420: '+420',
    _421: '+421'
} as const;

export type PhoneWithEnumedPrefixV3x1PrefixEnum = typeof PhoneWithEnumedPrefixV3x1PrefixEnum[keyof typeof PhoneWithEnumedPrefixV3x1PrefixEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const ProcessTypeV3x1 = {
    BANK_ID_ACTIVATION: 'BANK_ID_ACTIVATION',
    BANK_ID_ONBOARDING: 'BANK_ID_ONBOARDING',
    CONSULTANT_QR_ACTIVATION: 'CONSULTANT_QR_ACTIVATION',
    DEVICE_QR_ACTIVATION: 'DEVICE_QR_ACTIVATION',
    ID_SCAN_ACTIVATION: 'ID_SCAN_ACTIVATION'
} as const;

export type ProcessTypeV3x1 = typeof ProcessTypeV3x1[keyof typeof ProcessTypeV3x1];


/**
 * 
 * @export
 * @interface ProcessViewV3
 */
export interface ProcessViewV3 {
    /**
     * 
     * @type {string}
     * @memberof ProcessViewV3
     */
    'processUuid': string;
    /**
     * 
     * @type {ProcessTypeV3x1}
     * @memberof ProcessViewV3
     */
    'processType': ProcessTypeV3x1;
    /**
     * 
     * @type {UnifiedProcessStateV3x1}
     * @memberof ProcessViewV3
     */
    'processState': UnifiedProcessStateV3x1;
    /**
     * 
     * @type {string}
     * @memberof ProcessViewV3
     */
    'activationUserUuid': string;
    /**
     * 
     * @type {string}
     * @memberof ProcessViewV3
     */
    'activationUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessViewV3
     */
    'activationName'?: string;
    /**
     * 
     * @type {ClientV3x1}
     * @memberof ProcessViewV3
     */
    'client': ClientV3x1;
    /**
     * 
     * @type {boolean}
     * @memberof ProcessViewV3
     */
    'isPidVerified'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProcessViewV3
     */
    'deviceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessViewV3
     */
    'deviceFingerprint'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProcessViewV3
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProcessViewV3
     */
    'updatedAt': string;
    /**
     * 
     * @type {PhoneV3x1}
     * @memberof ProcessViewV3
     */
    'phone': PhoneV3x1;
}


/**
 * 
 * @export
 * @interface SearchProcessesSortV3
 */
export interface SearchProcessesSortV3 {
    /**
     * 
     * @type {string}
     * @memberof SearchProcessesSortV3
     */
    'name': SearchProcessesSortV3NameEnum;
    /**
     * 
     * @type {SortOrderTypeV1x0}
     * @memberof SearchProcessesSortV3
     */
    'order': SortOrderTypeV1x0;
}

export const SearchProcessesSortV3NameEnum = {
    CREATED_AT: 'CREATED_AT',
    UPDATED_AT: 'UPDATED_AT'
} as const;

export type SearchProcessesSortV3NameEnum = typeof SearchProcessesSortV3NameEnum[keyof typeof SearchProcessesSortV3NameEnum];

/**
 * Sorting order - ascendent or descendent.
 * @export
 * @enum {string}
 */

export const SortOrderTypeV1x0 = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;

export type SortOrderTypeV1x0 = typeof SortOrderTypeV1x0[keyof typeof SortOrderTypeV1x0];


/**
 * Contains all unified states available in the onboarding processes
 * @export
 * @enum {string}
 */

export const UnifiedProcessStateV3x1 = {
    ACTIVATION_COMMITTED: 'ACTIVATION_COMMITTED',
    ACTIVATION_CREATED: 'ACTIVATION_CREATED',
    ACTIVATION_INITIALIZED: 'ACTIVATION_INITIALIZED',
    BANK_ID_AUTHORIZATION_FAILED: 'BANK_ID_AUTHORIZATION_FAILED',
    DEVICE_APPROVED: 'DEVICE_APPROVED',
    DOCUMENTS_TO_SIGN_PREPARED: 'DOCUMENTS_TO_SIGN_PREPARED',
    IDENTITY_VERIFICATION_COMPLETED: 'IDENTITY_VERIFICATION_COMPLETED',
    IDENTITY_VERIFICATION_FAILED: 'IDENTITY_VERIFICATION_FAILED',
    IDENTITY_VERIFICATION_INITIATED: 'IDENTITY_VERIFICATION_INITIATED',
    IDENTITY_VERIFIED: 'IDENTITY_VERIFIED',
    MANUAL_IDENTITY_VERIFICATION_REQUIRED: 'MANUAL_IDENTITY_VERIFICATION_REQUIRED',
    PROCESS_CANCELED: 'PROCESS_CANCELED',
    PROCESS_COMPLETED: 'PROCESS_COMPLETED',
    PROCESS_CREATED: 'PROCESS_CREATED',
    SIGNED_DOCUMENTS_PROCESSING_COMPLETED: 'SIGNED_DOCUMENTS_PROCESSING_COMPLETED',
    SIGNED_DOCUMENTS_PROCESSING_FAILED: 'SIGNED_DOCUMENTS_PROCESSING_FAILED',
    USER_IMPORTED: 'USER_IMPORTED',
    USER_UPSERT_COMPLETED: 'USER_UPSERT_COMPLETED',
    USER_UPSERT_FAILED: 'USER_UPSERT_FAILED',
    USER_UPSERT_INITIATED: 'USER_UPSERT_INITIATED'
} as const;

export type UnifiedProcessStateV3x1 = typeof UnifiedProcessStateV3x1[keyof typeof UnifiedProcessStateV3x1];




/**
 * OnboardingApi - axios parameter creator
 * @export
 */
export const OnboardingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Executes task responsible for the approving identity.
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consultantQrActivationApproveIdentityTaskV3: async (processUuid: string, xCorrelationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processUuid' is not null or undefined
            assertParamExists('consultantQrActivationApproveIdentityTaskV3', 'processUuid', processUuid)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('consultantQrActivationApproveIdentityTaskV3', 'xCorrelationId', xCorrelationId)
            const localVarPath = `/pid-backofficegateway-pidonboarding/v3/processes/consultant-qr-activation/{processUuid}/tasks/approve-identity`
                .replace(`{${"processUuid"}}`, encodeURIComponent(String(processUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Executes task responsible for the declining identity.
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consultantQrActivationRejectIdentityTaskV3: async (processUuid: string, xCorrelationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processUuid' is not null or undefined
            assertParamExists('consultantQrActivationRejectIdentityTaskV3', 'processUuid', processUuid)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('consultantQrActivationRejectIdentityTaskV3', 'xCorrelationId', xCorrelationId)
            const localVarPath = `/pid-backofficegateway-pidonboarding/v3/processes/consultant-qr-activation/{processUuid}/tasks/reject-identity`
                .replace(`{${"processUuid"}}`, encodeURIComponent(String(processUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get list of all activations
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {GetActivationListRequestV3} getActivationListRequestV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivationListV3: async (xCorrelationId: string, getActivationListRequestV3: GetActivationListRequestV3, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getActivationListV3', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'getActivationListRequestV3' is not null or undefined
            assertParamExists('getActivationListV3', 'getActivationListRequestV3', getActivationListRequestV3)
            const localVarPath = `/pid-backofficegateway-pidonboarding/v3/activations/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getActivationListRequestV3, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Executes task responsible for the approving identity.
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idScanActivationApproveIdentityTaskV3: async (processUuid: string, xCorrelationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processUuid' is not null or undefined
            assertParamExists('idScanActivationApproveIdentityTaskV3', 'processUuid', processUuid)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('idScanActivationApproveIdentityTaskV3', 'xCorrelationId', xCorrelationId)
            const localVarPath = `/pid-backofficegateway-pidonboarding/v3/processes/id-scan-activation/{processUuid}/tasks/approve-identity`
                .replace(`{${"processUuid"}}`, encodeURIComponent(String(processUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Executes task responsible for the declining identity.
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idScanActivationRejectIdentityTaskV3: async (processUuid: string, xCorrelationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processUuid' is not null or undefined
            assertParamExists('idScanActivationRejectIdentityTaskV3', 'processUuid', processUuid)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('idScanActivationRejectIdentityTaskV3', 'xCorrelationId', xCorrelationId)
            const localVarPath = `/pid-backofficegateway-pidonboarding/v3/processes/id-scan-activation/{processUuid}/tasks/reject-identity`
                .replace(`{${"processUuid"}}`, encodeURIComponent(String(processUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated, replaced by /processes/id-scan-activation/{processUuid}/tasks/approve-identity. Executes task responsible for the approving identity. 
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        identityVerificationApproveIdentityTaskV3: async (processUuid: string, xCorrelationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processUuid' is not null or undefined
            assertParamExists('identityVerificationApproveIdentityTaskV3', 'processUuid', processUuid)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('identityVerificationApproveIdentityTaskV3', 'xCorrelationId', xCorrelationId)
            const localVarPath = `/pid-backofficegateway-pidonboarding/v3/processes/identity-verification/{processUuid}/tasks/approve-identity`
                .replace(`{${"processUuid"}}`, encodeURIComponent(String(processUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated, replaced by /processes/id-scan-activation/{processUuid}/tasks/reject-identity. Executes task responsible for the declining identity. 
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        identityVerificationRejectIdentityTaskV3: async (processUuid: string, xCorrelationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processUuid' is not null or undefined
            assertParamExists('identityVerificationRejectIdentityTaskV3', 'processUuid', processUuid)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('identityVerificationRejectIdentityTaskV3', 'xCorrelationId', xCorrelationId)
            const localVarPath = `/pid-backofficegateway-pidonboarding/v3/processes/identity-verification/{processUuid}/tasks/reject-identity`
                .replace(`{${"processUuid"}}`, encodeURIComponent(String(processUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated, replaced by /processes/consultant-qr-activation/{processUuid}/tasks/approve-identity. Executes task responsible for the approving identity. 
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        qrApproveIdentityTaskV3: async (processUuid: string, xCorrelationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processUuid' is not null or undefined
            assertParamExists('qrApproveIdentityTaskV3', 'processUuid', processUuid)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('qrApproveIdentityTaskV3', 'xCorrelationId', xCorrelationId)
            const localVarPath = `/pid-backofficegateway-pidonboarding/v3/processes/qr/{processUuid}/tasks/approve-identity`
                .replace(`{${"processUuid"}}`, encodeURIComponent(String(processUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deprecated, replaced by /processes/consultant-qr-activation/{processUuid}/tasks/reject-identity. Executes task responsible for the declining identity. 
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        qrRejectIdentityTaskV3: async (processUuid: string, xCorrelationId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processUuid' is not null or undefined
            assertParamExists('qrRejectIdentityTaskV3', 'processUuid', processUuid)
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('qrRejectIdentityTaskV3', 'xCorrelationId', xCorrelationId)
            const localVarPath = `/pid-backofficegateway-pidonboarding/v3/processes/qr/{processUuid}/tasks/reject-identity`
                .replace(`{${"processUuid"}}`, encodeURIComponent(String(processUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OnboardingApi - functional programming interface
 * @export
 */
export const OnboardingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OnboardingApiAxiosParamCreator(configuration)
    return {
        /**
         * Executes task responsible for the approving identity.
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consultantQrActivationApproveIdentityTaskV3(processUuid: string, xCorrelationId: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsultantQrActivationProcessV3x1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consultantQrActivationApproveIdentityTaskV3(processUuid, xCorrelationId, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Executes task responsible for the declining identity.
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async consultantQrActivationRejectIdentityTaskV3(processUuid: string, xCorrelationId: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsultantQrActivationProcessV3x1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.consultantQrActivationRejectIdentityTaskV3(processUuid, xCorrelationId, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get list of all activations
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {GetActivationListRequestV3} getActivationListRequestV3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivationListV3(xCorrelationId: string, getActivationListRequestV3: GetActivationListRequestV3, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActivationListResponseV3>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivationListV3(xCorrelationId, getActivationListRequestV3, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Executes task responsible for the approving identity.
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async idScanActivationApproveIdentityTaskV3(processUuid: string, xCorrelationId: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdScanActivationProcessV3x1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.idScanActivationApproveIdentityTaskV3(processUuid, xCorrelationId, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Executes task responsible for the declining identity.
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async idScanActivationRejectIdentityTaskV3(processUuid: string, xCorrelationId: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdScanActivationProcessV3x1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.idScanActivationRejectIdentityTaskV3(processUuid, xCorrelationId, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated, replaced by /processes/id-scan-activation/{processUuid}/tasks/approve-identity. Executes task responsible for the approving identity. 
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async identityVerificationApproveIdentityTaskV3(processUuid: string, xCorrelationId: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdScanActivationProcessV3x1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.identityVerificationApproveIdentityTaskV3(processUuid, xCorrelationId, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated, replaced by /processes/id-scan-activation/{processUuid}/tasks/reject-identity. Executes task responsible for the declining identity. 
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async identityVerificationRejectIdentityTaskV3(processUuid: string, xCorrelationId: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdScanActivationProcessV3x1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.identityVerificationRejectIdentityTaskV3(processUuid, xCorrelationId, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated, replaced by /processes/consultant-qr-activation/{processUuid}/tasks/approve-identity. Executes task responsible for the approving identity. 
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async qrApproveIdentityTaskV3(processUuid: string, xCorrelationId: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsultantQrActivationProcessV3x1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qrApproveIdentityTaskV3(processUuid, xCorrelationId, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Deprecated, replaced by /processes/consultant-qr-activation/{processUuid}/tasks/reject-identity. Executes task responsible for the declining identity. 
         * @param {string} processUuid Process identifier.
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async qrRejectIdentityTaskV3(processUuid: string, xCorrelationId: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsultantQrActivationProcessV3x1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.qrRejectIdentityTaskV3(processUuid, xCorrelationId, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OnboardingApi - factory interface
 * @export
 */
export const OnboardingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OnboardingApiFp(configuration)
    return {
        /**
         * Executes task responsible for the approving identity.
         * @param {OnboardingApiConsultantQrActivationApproveIdentityTaskV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consultantQrActivationApproveIdentityTaskV3(requestParameters: OnboardingApiConsultantQrActivationApproveIdentityTaskV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<ConsultantQrActivationProcessV3x1> {
            return localVarFp.consultantQrActivationApproveIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Executes task responsible for the declining identity.
         * @param {OnboardingApiConsultantQrActivationRejectIdentityTaskV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        consultantQrActivationRejectIdentityTaskV3(requestParameters: OnboardingApiConsultantQrActivationRejectIdentityTaskV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<ConsultantQrActivationProcessV3x1> {
            return localVarFp.consultantQrActivationRejectIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get list of all activations
         * @param {OnboardingApiGetActivationListV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivationListV3(requestParameters: OnboardingApiGetActivationListV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<GetActivationListResponseV3> {
            return localVarFp.getActivationListV3(requestParameters.xCorrelationId, requestParameters.getActivationListRequestV3, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Executes task responsible for the approving identity.
         * @param {OnboardingApiIdScanActivationApproveIdentityTaskV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idScanActivationApproveIdentityTaskV3(requestParameters: OnboardingApiIdScanActivationApproveIdentityTaskV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<IdScanActivationProcessV3x1> {
            return localVarFp.idScanActivationApproveIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Executes task responsible for the declining identity.
         * @param {OnboardingApiIdScanActivationRejectIdentityTaskV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        idScanActivationRejectIdentityTaskV3(requestParameters: OnboardingApiIdScanActivationRejectIdentityTaskV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<IdScanActivationProcessV3x1> {
            return localVarFp.idScanActivationRejectIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated, replaced by /processes/id-scan-activation/{processUuid}/tasks/approve-identity. Executes task responsible for the approving identity. 
         * @param {OnboardingApiIdentityVerificationApproveIdentityTaskV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        identityVerificationApproveIdentityTaskV3(requestParameters: OnboardingApiIdentityVerificationApproveIdentityTaskV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<IdScanActivationProcessV3x1> {
            return localVarFp.identityVerificationApproveIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated, replaced by /processes/id-scan-activation/{processUuid}/tasks/reject-identity. Executes task responsible for the declining identity. 
         * @param {OnboardingApiIdentityVerificationRejectIdentityTaskV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        identityVerificationRejectIdentityTaskV3(requestParameters: OnboardingApiIdentityVerificationRejectIdentityTaskV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<IdScanActivationProcessV3x1> {
            return localVarFp.identityVerificationRejectIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated, replaced by /processes/consultant-qr-activation/{processUuid}/tasks/approve-identity. Executes task responsible for the approving identity. 
         * @param {OnboardingApiQrApproveIdentityTaskV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        qrApproveIdentityTaskV3(requestParameters: OnboardingApiQrApproveIdentityTaskV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<ConsultantQrActivationProcessV3x1> {
            return localVarFp.qrApproveIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Deprecated, replaced by /processes/consultant-qr-activation/{processUuid}/tasks/reject-identity. Executes task responsible for the declining identity. 
         * @param {OnboardingApiQrRejectIdentityTaskV3Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        qrRejectIdentityTaskV3(requestParameters: OnboardingApiQrRejectIdentityTaskV3Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<ConsultantQrActivationProcessV3x1> {
            return localVarFp.qrRejectIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for consultantQrActivationApproveIdentityTaskV3 operation in OnboardingApi.
 * @export
 * @type OnboardingApiConsultantQrActivationApproveIdentityTaskV3Request
 */
export type OnboardingApiConsultantQrActivationApproveIdentityTaskV3Request = {
    /**
     * Process identifier.
     * @type {string}
     * @memberof OnboardingApiConsultantQrActivationApproveIdentityTaskV3
     */
    readonly processUuid: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof OnboardingApiConsultantQrActivationApproveIdentityTaskV3
     */
    readonly xCorrelationId: string
}

/**
 * Request parameters for consultantQrActivationRejectIdentityTaskV3 operation in OnboardingApi.
 * @export
 * @type OnboardingApiConsultantQrActivationRejectIdentityTaskV3Request
 */
export type OnboardingApiConsultantQrActivationRejectIdentityTaskV3Request = {
    /**
     * Process identifier.
     * @type {string}
     * @memberof OnboardingApiConsultantQrActivationRejectIdentityTaskV3
     */
    readonly processUuid: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof OnboardingApiConsultantQrActivationRejectIdentityTaskV3
     */
    readonly xCorrelationId: string
}

/**
 * Request parameters for getActivationListV3 operation in OnboardingApi.
 * @export
 * @type OnboardingApiGetActivationListV3Request
 */
export type OnboardingApiGetActivationListV3Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof OnboardingApiGetActivationListV3
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {GetActivationListRequestV3}
     * @memberof OnboardingApiGetActivationListV3
     */
    readonly getActivationListRequestV3: GetActivationListRequestV3
}

/**
 * Request parameters for idScanActivationApproveIdentityTaskV3 operation in OnboardingApi.
 * @export
 * @type OnboardingApiIdScanActivationApproveIdentityTaskV3Request
 */
export type OnboardingApiIdScanActivationApproveIdentityTaskV3Request = {
    /**
     * Process identifier.
     * @type {string}
     * @memberof OnboardingApiIdScanActivationApproveIdentityTaskV3
     */
    readonly processUuid: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof OnboardingApiIdScanActivationApproveIdentityTaskV3
     */
    readonly xCorrelationId: string
}

/**
 * Request parameters for idScanActivationRejectIdentityTaskV3 operation in OnboardingApi.
 * @export
 * @type OnboardingApiIdScanActivationRejectIdentityTaskV3Request
 */
export type OnboardingApiIdScanActivationRejectIdentityTaskV3Request = {
    /**
     * Process identifier.
     * @type {string}
     * @memberof OnboardingApiIdScanActivationRejectIdentityTaskV3
     */
    readonly processUuid: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof OnboardingApiIdScanActivationRejectIdentityTaskV3
     */
    readonly xCorrelationId: string
}

/**
 * Request parameters for identityVerificationApproveIdentityTaskV3 operation in OnboardingApi.
 * @export
 * @type OnboardingApiIdentityVerificationApproveIdentityTaskV3Request
 */
export type OnboardingApiIdentityVerificationApproveIdentityTaskV3Request = {
    /**
     * Process identifier.
     * @type {string}
     * @memberof OnboardingApiIdentityVerificationApproveIdentityTaskV3
     */
    readonly processUuid: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof OnboardingApiIdentityVerificationApproveIdentityTaskV3
     */
    readonly xCorrelationId: string
}

/**
 * Request parameters for identityVerificationRejectIdentityTaskV3 operation in OnboardingApi.
 * @export
 * @type OnboardingApiIdentityVerificationRejectIdentityTaskV3Request
 */
export type OnboardingApiIdentityVerificationRejectIdentityTaskV3Request = {
    /**
     * Process identifier.
     * @type {string}
     * @memberof OnboardingApiIdentityVerificationRejectIdentityTaskV3
     */
    readonly processUuid: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof OnboardingApiIdentityVerificationRejectIdentityTaskV3
     */
    readonly xCorrelationId: string
}

/**
 * Request parameters for qrApproveIdentityTaskV3 operation in OnboardingApi.
 * @export
 * @type OnboardingApiQrApproveIdentityTaskV3Request
 */
export type OnboardingApiQrApproveIdentityTaskV3Request = {
    /**
     * Process identifier.
     * @type {string}
     * @memberof OnboardingApiQrApproveIdentityTaskV3
     */
    readonly processUuid: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof OnboardingApiQrApproveIdentityTaskV3
     */
    readonly xCorrelationId: string
}

/**
 * Request parameters for qrRejectIdentityTaskV3 operation in OnboardingApi.
 * @export
 * @type OnboardingApiQrRejectIdentityTaskV3Request
 */
export type OnboardingApiQrRejectIdentityTaskV3Request = {
    /**
     * Process identifier.
     * @type {string}
     * @memberof OnboardingApiQrRejectIdentityTaskV3
     */
    readonly processUuid: string

    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof OnboardingApiQrRejectIdentityTaskV3
     */
    readonly xCorrelationId: string
}

/**
 * OnboardingApi - object-oriented interface
 * @export
 * @class OnboardingApi
 * @extends {BaseAPI}
 */
export class OnboardingApi extends BaseAPI {
    /**
     * Executes task responsible for the approving identity.
     * @param {OnboardingApiConsultantQrActivationApproveIdentityTaskV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public consultantQrActivationApproveIdentityTaskV3(requestParameters: OnboardingApiConsultantQrActivationApproveIdentityTaskV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return OnboardingApiFp(this.configuration).consultantQrActivationApproveIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Executes task responsible for the declining identity.
     * @param {OnboardingApiConsultantQrActivationRejectIdentityTaskV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public consultantQrActivationRejectIdentityTaskV3(requestParameters: OnboardingApiConsultantQrActivationRejectIdentityTaskV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return OnboardingApiFp(this.configuration).consultantQrActivationRejectIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get list of all activations
     * @param {OnboardingApiGetActivationListV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public getActivationListV3(requestParameters: OnboardingApiGetActivationListV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return OnboardingApiFp(this.configuration).getActivationListV3(requestParameters.xCorrelationId, requestParameters.getActivationListRequestV3, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Executes task responsible for the approving identity.
     * @param {OnboardingApiIdScanActivationApproveIdentityTaskV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public idScanActivationApproveIdentityTaskV3(requestParameters: OnboardingApiIdScanActivationApproveIdentityTaskV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return OnboardingApiFp(this.configuration).idScanActivationApproveIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Executes task responsible for the declining identity.
     * @param {OnboardingApiIdScanActivationRejectIdentityTaskV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public idScanActivationRejectIdentityTaskV3(requestParameters: OnboardingApiIdScanActivationRejectIdentityTaskV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return OnboardingApiFp(this.configuration).idScanActivationRejectIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated, replaced by /processes/id-scan-activation/{processUuid}/tasks/approve-identity. Executes task responsible for the approving identity. 
     * @param {OnboardingApiIdentityVerificationApproveIdentityTaskV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public identityVerificationApproveIdentityTaskV3(requestParameters: OnboardingApiIdentityVerificationApproveIdentityTaskV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return OnboardingApiFp(this.configuration).identityVerificationApproveIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated, replaced by /processes/id-scan-activation/{processUuid}/tasks/reject-identity. Executes task responsible for the declining identity. 
     * @param {OnboardingApiIdentityVerificationRejectIdentityTaskV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public identityVerificationRejectIdentityTaskV3(requestParameters: OnboardingApiIdentityVerificationRejectIdentityTaskV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return OnboardingApiFp(this.configuration).identityVerificationRejectIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated, replaced by /processes/consultant-qr-activation/{processUuid}/tasks/approve-identity. Executes task responsible for the approving identity. 
     * @param {OnboardingApiQrApproveIdentityTaskV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public qrApproveIdentityTaskV3(requestParameters: OnboardingApiQrApproveIdentityTaskV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return OnboardingApiFp(this.configuration).qrApproveIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deprecated, replaced by /processes/consultant-qr-activation/{processUuid}/tasks/reject-identity. Executes task responsible for the declining identity. 
     * @param {OnboardingApiQrRejectIdentityTaskV3Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof OnboardingApi
     */
    public qrRejectIdentityTaskV3(requestParameters: OnboardingApiQrRejectIdentityTaskV3Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return OnboardingApiFp(this.configuration).qrRejectIdentityTaskV3(requestParameters.processUuid, requestParameters.xCorrelationId, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


